import React from 'react';
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import { FaGithub, FaLinkedin, FaArrowDown } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';
import HeroImg from '../../images/profile_pic.jpeg';
import './styles.css';

export default function Hero() {
  return (
    <section className="hero" id="hero">
      {/* Gradient orbs */}
      <div className="hero__orb hero__orb--1" />
      <div className="hero__orb hero__orb--2" />
      <div className="hero__orb hero__orb--3" />

      <div className="hero__grid">
        {/* Left content */}
        <div className="hero__content">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            Currently building at Deepsolv AI
          </div>

          <h1 className="hero__name">
            {Bio.name}
            <span className="hero__name-accent">.</span>
          </h1>

          <div className="hero__role">
            <Typewriter
              options={{
                strings: Bio.roles,
                autoStart: true,
                loop: true,
                deleteSpeed: 30,
                delay: 60,
              }}
            />
          </div>

          <p className="hero__desc">{Bio.description}</p>

          <div className="hero__actions">
            <a href={Bio.resume} target="_blank" rel="noreferrer" className="hero__btn hero__btn--primary">
              Resume
              <span className="hero__btn-arrow">&rarr;</span>
            </a>
            <a href="#contact" className="hero__btn hero__btn--secondary">
              Get in Touch
            </a>
          </div>

          <div className="hero__socials">
            <a href={Bio.github} target="_blank" rel="noreferrer" className="hero__social" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href={Bio.linkedin} target="_blank" rel="noreferrer" className="hero__social" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href={Bio.leetcode} target="_blank" rel="noreferrer" className="hero__social" aria-label="LeetCode">
              <SiLeetcode />
            </a>
          </div>
        </div>

        {/* Right — photo */}
        <div className="hero__photo-wrap">
          <div className="hero__photo-glow" />
          <img src={HeroImg} alt={Bio.name} className="hero__photo" />
        </div>
      </div>

      {/* Scroll indicator */}
      <a href="#experience" className="hero__scroll" aria-label="Scroll down">
        <FaArrowDown />
      </a>
    </section>
  );
}
